import React from "react";
import { connect } from "react-redux";

import { IAppState } from "../../state/Store";

interface MessagingBroadcastsProps {
    broadcasting: boolean;
    broadcastType: number;
    broadcastTypeChanged: (type: number) => void;
}

class MessagingBroadcasts extends React.Component<MessagingBroadcastsProps> {
    render(): React.ReactNode {
        return (
            this.props.broadcasting && (
                <div className="col-pane broadcast-controls">
                    <div className="flex-row group bottom-clearance-small">
                        <label className="radio button grey col text-center">
                            <input
                                type="radio"
                                name="broadcastType"
                                checked={this.props.broadcastType === 1}
                                onChange={() =>
                                    this.props.broadcastTypeChanged(1)
                                }
                            />
                            <span className="checkmark"></span>
                            <span className="text">All Users</span>
                            <span className="backing"></span>
                        </label>
                        <label className="radio button grey col text-center">
                            <input
                                type="radio"
                                name="broadcastType"
                                checked={this.props.broadcastType === 2}
                                onChange={() =>
                                    this.props.broadcastTypeChanged(2)
                                }
                            />
                            <span className="checkmark"></span>
                            <span className="text">
                                Current School Users Only
                            </span>
                            <span className="backing"></span>
                        </label>
                    </div>
                </div>
            )
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MessagingBroadcasts);
